export default "__VITE_ASSET__DXQ6YskI__"